interface CompletionPayload {
  type: 'financial-promotions.done'
  authCode: string
}

// Fixed names hosts register under — published in the integration spec, not configurable.
// iOS: WKUserContentController.add(handler, name: "financialPromotionsBridge")
// Android: addJavascriptInterface(obj, "financialPromotionsBridge")
enum Bridge {
  ReactNative = 'react-native',
  IOS = 'ios',
  Android = 'android',
  Iframe = 'iframe',
}

const detectBridge = (): Bridge | null => {
  const w = window as any
  if (w.ReactNativeWebView) return Bridge.ReactNative
  if (w.webkit?.messageHandlers?.financialPromotionsBridge) return Bridge.IOS
  if (w.financialPromotionsBridge) return Bridge.Android
  if (window.parent !== window) return Bridge.Iframe
  return null
}

const bridgeHandlers: Record<Bridge, (payload: CompletionPayload) => void> = {
  [Bridge.ReactNative]: payload =>
    (window as any).ReactNativeWebView.postMessage(JSON.stringify(payload)),
  [Bridge.IOS]: payload =>
    (
      window as any
    ).webkit.messageHandlers.financialPromotionsBridge.postMessage(payload),
  [Bridge.Android]: payload =>
    (window as any).financialPromotionsBridge.postMessage(
      JSON.stringify(payload),
    ),
  [Bridge.Iframe]: payload => window.parent.postMessage(payload, '*'),
}

export const hasHostBridge = (): boolean => detectBridge() !== null

export const canReturnToApp = (deepLinkURI?: string): boolean =>
  hasHostBridge() || !!deepLinkURI

export const returnToApp = (
  authCode: string,
  deepLinkURI?: string,
): boolean => {
  const bridge = detectBridge()
  if (bridge) {
    bridgeHandlers[bridge]({ type: 'financial-promotions.done', authCode })
  }
  if (deepLinkURI) {
    window.open(`${deepLinkURI}/${authCode}`, '_self')
  }
  return bridge !== null || !!deepLinkURI
}
